import _ from 'lodash'

export function resolveGlobalConfig(
  createGlobalConfig,
  { runtimeConfig, serverRuntimeConfig }
) {
  const globalConfig = _.merge({}, frameworkGlobal(), createGlobalConfig())

  // prefetch 相关校验
  if (globalConfig.prefetchApi) {
    Object.keys(globalConfig.prefetchApi).forEach((propKey) => {
      const taskConf = globalConfig.prefetchApi[propKey]
      if ('enabled' in taskConf) {
        throw new Error(`global 不支持 prefetchApi 指定 enabled`)
      }
      if (!taskConf.critical) {
        throw new Error(`global 的 prefetchApi 必须指定为关键任务`)
      }
    })
  }
  if (globalConfig.prefetchApiFallback) {
    throw new Error(`global 不支持 prefetchApiFallback`)
  }
  if (globalConfig.prefetchApiCallback) {
    throw new Error(`global 不支持 prefetchApiCallback`)
  }

  // TODO globalConfig 返回格式校验

  // 未声明 redux 时提供默认值
  if (!globalConfig.redux) {
    globalConfig.redux = {
      actions: {},
      reducer: (v = {}) => v,
    }
  }

  // 未声明 i18n 时提供默认值
  if (!globalConfig.i18n) {
    globalConfig.i18n = {
      resolve: () => ({ lang: undefined, locale: {}, format: undefined }),
      resource: {},
    }
  }

  // 未声明 env 时提供默认值
  if (!globalConfig.env) {
    globalConfig.env = (ctx, initialEnv) => {
      if (process.server) {
        return process.env.RUNTIME_ENV
      } else {
        return initialEnv
      }
    }
  }

  return globalConfig
}

function frameworkGlobal() {
  // console.log('framework', !process.browser ? 'server' : 'browser', 'global')
  return {
    //env为空时的兼容
    env: () => undefined,
  }
}
